import React from 'react';
import styled from '@emotion/styled';

import { COLOR_GREEN } from 'client/components/MarketingPagesShared/styles';
import { useT } from 'client/i18n/hooks/useT';
import { SCREEN_BREAKPOINTS } from '../../constants';

const QuoteFigure = styled.figure`
  width: 100%;
  max-width: 968px;
  margin: 0 auto 48px;
  color: ${COLOR_GREEN};
`;

const QuoteBlockquote = styled.blockquote`
  margin: 0 0 24px;
  padding: 0 24px;
  border: none;
  font-weight: 900;
  font-size: 2.25rem;
  line-height: 2.5rem;
  text-align: center;
  @media (max-width: ${SCREEN_BREAKPOINTS.MOBILE}px) {
    font-size: 1.25rem;
    line-height: 1.875rem;
  }
`;

const QuoteFigcaption = styled.figcaption`
  font-size: 1.25rem;
  line-height: 1.875rem;
  text-align: center;
`;

export const Blockquote = () => {
  const t = useT();
  return (
    <QuoteFigure>
      <QuoteBlockquote>
        {t(
          'AdsByAnchorScreen.Quote.Blockquote',
          '"I\'m really excited to tap into the Spotify Audience Network as an Anchor creator. Anchor\'s been an amazing platform, and has helped my podcast grow to where it is now. I have full confidence that their monetization tools will continue to help creators like me expand our businesses further."',
          'Anchor creator experience quote'
        )}
      </QuoteBlockquote>
      <QuoteFigcaption>
        <cite>
          {t(
            'AdsByAnchorScreen.Quote.Blockquote.Creator',
            'Creator of rSlash',
            'Who said the quote in Ads by Anchor page'
          )}
        </cite>
      </QuoteFigcaption>
    </QuoteFigure>
  );
};
